import logo1 from '../../../Assets/Icons/award1.svg';
import logo2 from '../../../Assets/Icons/award2.svg';
import logo3 from '../../../Assets/Icons/award3.svg';

export const awardsList =[
    {
        logo:logo1,
        desc:"Best Product & Design Team 2021 Best Perks & Benefits 2020 "
    },
    {
        logo:logo2,
        desc:"Ranked #3 50 Best Remote-First Companies 2021"
    },
    {
        logo:logo3,
        desc:"Wealthfront Top Career-Launching Company 2021"
    }
]